import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { removeFromCart, updateQuantity } from '../../Utilities/cartSlice';
import { DeleteOutlined } from '@ant-design/icons';
import './CartItemDetails.css';

function CartItemDetails({ item }) {
  console.log('CartItemDetails received:', item);
  const dispatch = useDispatch();

  // Generate Thumbnail Source - Updated to use UID format
  const thumbnailSrc = useMemo(() => {
    if (item.id) {
      const newUrl = `https://beyondschools.co.tz:8443/api/Public/get-class-thumbnail/${item.id}`;
      console.log('Using new URL format:', newUrl);
      return newUrl;
    }
  },);

  // Format title based on item type
  const displayTitle = item.type === 'subscription' 
    ? item.title.replace(' - Video Subscription', '') 
    : item.title;

  return (
    <div className='cart-item'>
      <div className='cart-item-image'>
        <img 
          src={thumbnailSrc} 
          alt={item.title} 
          className='cart-item-thumbnail' 
          onError={(e) => {
            e.target.src = 'path-to-default-image.jpg';
          }}
        />
      </div>
      
      <div className='cart-item-content'>
        <div className='cart-item-details'>
          <h4 className='cart-item-title'>{displayTitle}</h4>
          {item.type === 'subscription' && (
            <div className='cart-item-subscription-badge'>Subscription</div>
          )}
          <div className='cart-item-meta'>
            <span className='cart-item-instructor'>{item.instructor}</span>
            <span className='cart-item-education'>{item.education_class}</span>
          </div>
        </div>

        <div className='cart-item-controls'>
          <div className='cart-item-price'>
            Tsh {(item.price * (item.quantity || 1)).toLocaleString()}
          </div>

          <button 
            className='remove-btn'
            onClick={() => dispatch(removeFromCart(item.id))}
            aria-label="Remove item"
          >
            <DeleteOutlined className='remove-icon' />
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartItemDetails;